import { render, staticRenderFns } from "./PromoActionUpdate.vue?vue&type=template&id=1a7a90e4&scoped=true&"
import script from "./PromoActionUpdate.vue?vue&type=script&lang=js&"
export * from "./PromoActionUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a7a90e4",
  null
  
)

export default component.exports